import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import theme from 'ui/theme';
import ReactTable from 'ui/ReactTable';
import 'react-table/react-table.css';


import { reqClientifyFilters } from '$redux/clientifies/actions';

import Failed from '$routes/Failed';

import { Wrapper } from './styles';

class Grid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      sorted: [],
    };
  }

  fetchData = (state) => {
    const { dispatch } = this.props;
    const { pageSize, page, sorted } = state;
    const bindingObject = {
      pageSize,
      page,
      sorted,
      filters: {},
    };
    dispatch(reqClientifyFilters(bindingObject));
    // eslint-disable-next-line react/no-unused-state
    this.setState({ sorted });
  }

  render() {
    const {
      loading, pages, pageSize, data,
    } = this.props;

    if (!data) return <Failed />;

    return (
      <Wrapper theme={theme}>
        <ReactTable
          topBorder
          columns={[
            {
              Header: 'ID',
              accessor: 'idClientify',
              width: 120,
            },
            {
              Header: 'Status',
              accessor: 'status',
              width: 120,
            },
            {
              Header: 'Mode',
              accessor: 'mode',
              width: 120,
            },
            {
              Header: 'Request',
              accessor: 'request',
              width: 80,
            },
            {
              Header: 'Response',
              accessor: 'response',
            },
            {
              Header: 'Actualizado',
              accessor: 'updatedAt',
            },
          ]}
          manual
          defaultPageSize={pageSize}
          data={data}
          pages={pages} // Display the total number of pages
          loading={loading} // Display the loading overlay when we need it
          onFetchData={this.fetchData} // Request new data when things change
        />
      </Wrapper>
    );
  }
}

Grid.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.array,
  pages: PropTypes.number,
  pageSize: PropTypes.number,
  loading: PropTypes.bool.isRequired,
};

Grid.defaultProps = {
  data: [],
  pageSize: 10,
  pages: 0,
};

export default connect(
  state => ({
    data: state.clientifies.data,
    pages: state.clientifies.pages,
    loading: state.clientifies.loading,
  }),
)(Grid);
